// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__ijByo","item":"PaymentsMobile_item__275SH","label":"PaymentsMobile_label__wBqa1","amount":"PaymentsMobile_amount__2seZR"};